export const authTypes = {
  ATTEMPT: 'auth/ATTEMPT',
  RESPONSE: 'auth/RESPONSE',
  SUCCESS: 'auth/SUCCESS',
  FAIL: 'auth/FAIL',
  SYNC: 'auth/SYNC_SOCIAL_ACOUNT',
  SYNC_RESPONSE: 'auth/SYNC_RESPONSE',
  LEAVE_HACKATHON: 'auth/LEAVE_HACKATHON',
  LEAVE_RESPONSE: 'auth/LEAVE_RESPONSE',
  SEND_ACTIVATION_CODE: 'auth/SEND_ACTIVATION_CODE',
  SEND_CODE_RES: 'auth/SEND_ACTIVATION_CODE_RESPONSE'
}

export const authAttempt = (credentials) => (
  {
    type: authTypes.ATTEMPT,
    credentials
  }
)

export const authSuccess = () => (
  {
    type: authTypes.SUCCESS
  }
)

export const authFail = () => (
  {
    type: authTypes.FAIL
  }
)

export const authSync = (profileData) => (
  {
    type: authTypes.SYNC,
    profileData
  }
)

export const leaveHackathon = () => (
  {
    type: authTypes.LEAVE_HACKATHON
  }
)

export const sendActivationCode = (email) => (
  {
    type: authTypes.SEND_ACTIVATION_CODE,
    email
  }
)



// WEBPACK FOOTER //
// ./src/actions/auth.js